import Vue from 'vue'
import gql from 'graphql-tag'

const query = gql`
  query campaignByGender ( $campaignId: ID! ) {
    campaignByGender (campaignId: $campaignId
    ) {
      averageTicketPaidValue
      campaignGoal
      convertedCount
      createdCount
      convertedPaymentAmount
      convertedToPaymentPercent
      chargedAmount
      label
      percentConvertedCreated
      totalAmountPaid
    }
  }
`

/**
 * @param {*} campaignId
 **/

 async function getCampaignByGenderQuery( params ) {
  const { $api } = Vue.prototype
  const data = await $api.query({
    query,
    fetchPolicy: 'no-cache',
    variables: params
  }).then( res => res )
  .catch( e => e )
  return data;
}

export { getCampaignByGenderQuery }
